import React from 'react'
import styles from './styles'
import { image } from 'services'

export const CircleImage = ({ img, alt, center }) => (
  <div className={center ? 'center' : ''}>
    <img src={image('icons', img)} alt={alt} />
    <style jsx>{styles}</style>
  </div>
)

export default CircleImage
